import { getLocale } from "../runtime";

const sv_addtocart = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Lägg i varukorgen`
};

const addtocart = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_addtocart(inputs)
	return "addToCart";
};

export { addtocart as "addToCart" };